import axios from "axios";
import toast from "react-hot-toast";
import Cookie from "utils/cookie";
import { trackEvent } from "utils/analytics";
export const SET_USER_DETAILS = "set_user_details";
export const setUserDetails = (response = {}) => {
  return (dispatch) => {
    dispatch({
      type: SET_USER_DETAILS,
      payload: response,
    });
  };
};

export const updateNotificationPreference = (data) => {
  return (dispatch, getState) => {
    const userDetails = getState().user.userDetails || {};
    const { type } = userDetails;
    const url =
      type === "OWNER"
        ? "/api/owner/notification_preferences"
        : "/api/coach/notification_preferences";
    return axios
      .patch(url, data)
      .then((res) => {
        toast.success("Vos préférences de notification ont été enregistrées.");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
};

export const changePassword = (data) => {
  return (dispatch, getState) => {
    const userDetails = getState().user.userDetails || {};
    const { type } = userDetails;
    const url =
      type === "OWNER"
        ? "/api/owner/me/changepassword"
        : "/api/coach/me/changepassword";
    return axios
      .post(url, data)
      .then((res) => {
        toast.success("Votre mot de passe a été changé avec succès.");
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
};

export const SET_USER_PROFILE = "set_user_profile";
export const getProfile = () => {
  return (dispatch, getState) => {
    const userDetails = getState().user.userDetails || {};
    const { type } = userDetails;
    const url = type === "OWNER" ? "/api/owner/me" : type === "ADMIN" ? "/api/admin/me" : "/api/coach/me";
    return axios
      .get(url)
      .then((res) => {
        dispatch({
          type: SET_USER_PROFILE,
          payload: res.data.data,
        });
        // Sync subscription data to cookie so NavItems stays in sync
        const subscription = res.data.data?.organization?.subscription;
        if (subscription) {
          const user = Cookie.getParsedUser() || {};
          user.subscription = subscription;
          Cookie.save("user", JSON.stringify(user));
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
};

export const updateProfile = (data, flag = "") => {
  return (dispatch, getState) => {
    const userDetails = getState().user.userDetails || {};
    const userProfile = getState().user.userProfile || {};
    const { type } = userDetails;
    const url =
      type === "OWNER" ? "/api/owner/updateMe" : type === "ADMIN" ? "/api/admin/me" : "/api/coach/updateMe";
    return axios
      .patch(url, data)
      .then((res) => {
        const updateProfile = {
          ...userProfile,
          ...data,
        };

        dispatch({
          type: SET_USER_PROFILE,
          payload: updateProfile,
        });
        if (flag !== "photo_upload") {
          toast.success("Détails du profil sauvegardés.");
          trackEvent('Settings', 'profile_updated');
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
};

export const deleteMyAccount = (toggleDeleteModal) => {
  return (dispatch, getState) => {
    const userDetails = getState().user.userDetails || {};
    const { type } = userDetails;
    const url = type === "OWNER" ? "/api/owner/disable" : type === "ADMIN" ? "/api/admin/me" : "/api/disable";

    return axios
      .delete(url)
      .then((res) => {
        Cookie.delete("jwt");
        Cookie.delete("user");
        window.location.href = "/login";
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };
};

export const getStripeBillingPortalLink = () => {
  return () => {
    return axios
      .get("/api/me/stripe/portal_link")
      .then((res) => {
        const url = res.data.data;
        if (url) {
          trackEvent('Subscription', 'subscription_portal_opened');
          window.open(url, "_blank");
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            "Impossible d'accéder au portail de facturation."
        );
      });
  };
};

export const submitCancellationReason = (data) => {
  return () => {
    return axios
      .post("/api/owner/cancellation_reason", data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error("Failed to submit cancellation reason", err);
      });
  };
};

export const SET_ORGANIZATION = "set_organization";
export const updateOrganization = (data) => {
  return (dispatch, getState) => {
    const userDetails = getState().user.userDetails || {};
    const { org_id } = userDetails;
    const userProfile = getState().user.userProfile || {};
    return axios
      .patch(`/api/organization/${org_id}`, data)
      .then((res) => {
        dispatch({
          type: SET_USER_PROFILE,
          payload: {
            ...userProfile,
            organization: {
              ...userProfile.organization,
              ...data,
            },
          },
        });
        toast.success("Personnalisation sauvegardée.");
        trackEvent('Settings', 'branding_updated');
      })
      .catch((err) => {
        const msg = err?.response?.data?.message;
        toast.error(typeof msg === "string" ? msg : "Erreur lors de la sauvegarde.");
      });
  };
};

export const markWelcomeVideoSeen = () => {
  return (dispatch, getState) => {
    const userProfile = getState().user.userProfile || {};
    const url = "/api/me/welcome_video";
    return axios
      .patch(url)
      .then((res) => {
        const updateProfile = {
          ...userProfile,
          hasSeenWelcomeVideo: true,
        };
        dispatch({
          type: SET_USER_PROFILE,
          payload: updateProfile,
        });
      })
      .catch((err) => {
        console.error("Failed to mark welcome video as seen", err);
      });
  };
};
